import React from 'react';

const Generic = () => {
  return <div>Generic</div>;
};

export default Generic;
